import { render, staticRenderFns } from "./PercentOutlineWidget.vue?vue&type=template&id=3bb236b6&scoped=true"
import script from "./PercentOutlineWidget.vue?vue&type=script&lang=ts"
export * from "./PercentOutlineWidget.vue?vue&type=script&lang=ts"
import style0 from "./PercentOutlineWidget.vue?vue&type=style&index=0&id=3bb236b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb236b6",
  null
  
)

export default component.exports